import { render } from '@wordpress/element';

import './style.scss';
import Style from './Style';

// Video Background
document.addEventListener('DOMContentLoaded', () => {
	const allVideoBG = document.querySelectorAll('.wp-block-vbb-video-bg');
	allVideoBG.forEach(videoBG => {
		const { attributes, content } = JSON.parse(videoBG.dataset.props);

		render(<VideoBackground attributes={attributes} content={content} />, videoBG);

		videoBG?.removeAttribute('data-props');
	});
});

const VideoBackground = ({ attributes, content }) => {
	const { cId, video } = attributes;

	return <>
		<Style attributes={attributes} clientId={cId} />

		<video autoPlay muted loop className='vbbVideoPlayer'>
			<source src={video?.url} type='video/mp4' />

			Your browser does not support HTML5 video.
		</video>

		<div className='vbbVideoOverlay'></div>

		<div className='vbbVideoContent' dangerouslySetInnerHTML={{ __html: content }} />
	</>;
}